import { render, staticRenderFns } from "./ScopeOfPracticeCategoryInformation.vue?vue&type=template&id=6de6e535&scoped=true&"
import script from "./ScopeOfPracticeCategoryInformation.vue?vue&type=script&lang=js&"
export * from "./ScopeOfPracticeCategoryInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de6e535",
  null
  
)

export default component.exports